import config from 'crm/config'

const customerApi = `${config.apiHost}/oem-customer`

export default {
    getTableData: {
        url: `${customerApi}/api/oem_miniso/customer_stat/by_channel`,
        type: 'GET',
    },
    getStat: {
        url: `${customerApi}/api/oem_miniso/customer_stat/summary`,
        type: 'GET',
    },
    exportExcel: {
        url: `${customerApi}/api/customer_stat/by_channel.xlsx`,
        type: 'GET',
    },
    mainMinisoExportExcel: {
        url: `${customerApi}/api/oem_miniso/customer_stat/by_channel.xlsx`,
        type: 'GET',
    },
    // 渠道统计-明细-日期统计
    detailStatByDate: {
        url: `${customerApi}/api/oem_miniso/customer_stat/by_date`,
        type: 'GET',
    },
    // 渠道统计-明细-时间段统计
    detailStatByHour: {
        url: `${customerApi}/api/oem_miniso/customer_stat/by_hour`,
        type: 'GET',
    },
}
